import { useMutation, useQuery } from "@apollo/client";
import {
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1FieldsFragment,
  CredentialVerificationCaseV1ActivityLogInput,
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryDocument,
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationDocument
} from "../../../../../../generated";
import { ActivityLog } from "./activity-log";
import { message } from "antd";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

export interface ActivityLogDetailProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const ActivityLogContainer: React.FC<ActivityLogDetailProps> = (
  props
) => {
  const {
    data: activityLogData,
    loading: activityLogLoading,
    error: activityLogError,
  } = useQuery(
    CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryDocument,
    {
      variables: {
        credentialVerificationCaseV1Id: props.caseId,
      },
    }
  );

  const [activityLogAddUpdateActivity] = useMutation(CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationDocument);

  const handleAddUpdateActivity = async (
    values: CredentialVerificationCaseV1ActivityLogInput
  ) => {
    try {
      const { data } = await activityLogAddUpdateActivity({
        variables: {
          input: {
            id: props.caseId,
            activityLog: [...(activityLogData?.credentialVerificationCaseV1?.activityLog?.map((a) => ({ id: a?.id })) ?? []), values]
          },
        },
      });
      if (data?.credentialVerificationCaseV1Update?.status?.success) {
        message.success("Activity added successfully");
      } else {
        message.error(
          `Error adding activity : ${data?.credentialVerificationCaseV1Update?.status?.errorMessage}`
        );
      }
    } catch (error) {
      message.error(
        `Error adding activity : ${JSON.stringify(error)}`
      );
    }
  };

  return (
    <ComponentQueryLoader
      loading={activityLogLoading}
      error={activityLogError}
      hasData={activityLogData?.credentialVerificationCaseV1}
      hasDataComponent={
        <ActivityLog
          data={activityLogData?.credentialVerificationCaseV1 as CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1FieldsFragment}
          onAddUpdateActivity={handleAddUpdateActivity}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }

    />
  );
};
